import { useCallback, useMemo } from 'react';
import { useSmsDashboardSocket } from 'infrastructure/hooks/smsDashboard/useSmsDashboardSocket';
import { useSmsDashboardUnreadCount } from 'infrastructure/hooks/smsDashboard/useUnreadConversationsCount';

import type { ISocketData as INewMessageSocketData } from 'infrastructure/hooks/smsDashboard/useNewMessageBroadcast';

interface IProps {
  canLoadCount?: boolean;
}

export const useBadge = ({ canLoadCount }: IProps) => {
  const {
    unreadConversationsCount,
    updateUnreadCountByType,
    updateUnreadCount,
  } = useSmsDashboardUnreadCount({
    canLoad: canLoadCount,
  });

  const hasMessages = useMemo(() => {
    return (
      Object.values(unreadConversationsCount).reduce((a, b) => a + b, 0) > 0
    );
  }, [
    unreadConversationsCount.ccmTotalUnreadCount,
    unreadConversationsCount.rpmTotalUnreadCount,
    unreadConversationsCount.unregisteredCcmTotalUnreadCount,
    unreadConversationsCount.unregisteredRpmTotalUnreadCount,
  ]);

  const newMessage = useCallback(
    (data: INewMessageSocketData) => {
      if (canLoadCount && data.message.authorType === 'patient') {
        updateUnreadCountByType(data.type, data.unreadMessageCount);
      }
    },
    [updateUnreadCountByType, canLoadCount],
  );

  const conversationStateChange = useCallback(
    (data: any) => {
      if (canLoadCount) updateUnreadCount(data);
    },
    [updateUnreadCount, canLoadCount],
  );

  useSmsDashboardSocket({
    newMessage,
    conversationStateChange,
  });

  return {
    hasMessages,
  };
};
